import {Factory as DK_MLB_Factory} from './draftkings-mlb/factory';
import {Factory as FD_MLB_Factory} from './fanduel-mlb/factory';
import {Factory as DK_NBA_Factory} from './draftkings-nba/factory';
import {Factory as FD_NBA_Factory} from './fanduel-nba/factory';
import {Factory as DK_NFL_Factory} from './draftkings-nfl/factory';
import {Factory as DK_NHL_Factory} from './draftkings-nhl/factory';
import {Factory as DK_LOL_Factory} from './draftkings-lol/factory';
import {Factory as FD_LOL_Factory} from './fanduel-lol/factory';
import {Factory as FD_NFL_Factory} from './fanduel-nfl/factory';
import {Factory as FD_NHL_Factory} from './fanduel-nhl/factory';
import {Factory as DK_GOLF_Factory} from './draftkings-golf/factory';
import {Factory as FD_GOLF_Factory} from './fanduel-golf/factory';
import {Factory as DK_NASCAR_Factory} from './draftkings-nascar/factory';
import {Factory as FD_NASCAR_Factory} from './fanduel-nascar/factory';
import {Factory as DK_MMA_Factory} from './draftkings-mma/factory';
import {Factory as FD_MMA_Factory} from './fanduel-mma/factory';
import {Factory as DK_CFB_Factory} from './draftkings-cfb/factory';
import {Factory as FD_CFB_Factory} from './fanduel-cfb/factory';
import {Factory as YAHOO_NFL_Factory} from './yahoo-nfl/factory';
import {Factory as DK_TENNIS_Factory} from './draftkings-tennis/factory';
import {Factory as DK_F1_Factory} from './draftkings-f1/factory';
import BaseFactory from 'services/sports/default/base-factory';

const servicesMap = {
    draftkings: {
        cfb: DK_CFB_Factory,
        f1: DK_F1_Factory,
        golf: DK_GOLF_Factory,
        lol: DK_LOL_Factory,
        mlb: DK_MLB_Factory,
        mma: DK_MMA_Factory,
        nascar: DK_NASCAR_Factory,
        nba: DK_NBA_Factory,
        nfl: DK_NFL_Factory,
        nhl: DK_NHL_Factory,
        tennis: DK_TENNIS_Factory,
    },
    fanduel: {
        cfb: FD_CFB_Factory,
        golf: FD_GOLF_Factory,
        lol: FD_LOL_Factory,
        mlb: FD_MLB_Factory,
        mma: FD_MMA_Factory,
        nascar: FD_NASCAR_Factory,
        nba: FD_NBA_Factory,
        nfl: FD_NFL_Factory,
        nhl: FD_NHL_Factory,
    },
    yahoo: {
        nfl: YAHOO_NFL_Factory,
    },
};

export function getService(sportConfig): BaseFactory {
    const site = sportConfig.getSite().toLowerCase();
    const sport = sportConfig.getSport().toLowerCase();

    try {
        return new servicesMap[site][sport](sportConfig);
    } catch (e) {
        if (e instanceof TypeError) {
            throw new Error(`getSportBehaviour ERR: unknown ${site}/${sport}`);
        }
        throw e;
    }
}

export function getPlayerService(sportConfig, params = {}) {
    return getService(sportConfig).createObj('Player', params);
}

export function getLineupService(sportConfig, params = {}) {
    return getService(sportConfig).createObj('Lineup', params);
}

export function getLpService(sportConfig, params = {}) {
    return getService(sportConfig).createObj('LP', params);
}

export function getSettingsService(sportConfig, params = {}) {
    return getService(sportConfig).createObj('Settings', params);
}

export function getSimplexService(sportConfig, params = {}) {
    return getService(sportConfig).createObj('Simplex', params);
}

export function getUserSettingsValidator(sportConfig, params = {}) {
    return getService(sportConfig).createObj('UserAdjustmentsValidator', params);
}

export function getEditedLineupValidator(sportConfig, params = {}) {
    return getService(sportConfig).createObj('EditedLineupValidator', params);
}
